import { render } from "./CostingDetailModal.vue?vue&type=template&id=0787b457"
import script from "./CostingDetailModal.vue?vue&type=script&lang=js"
export * from "./CostingDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__